import { render, staticRenderFns } from "./MapContextMenuObject.vue?vue&type=template&id=87fb9968&"
import script from "./MapContextMenuObject.vue?vue&type=script&lang=js&"
export * from "./MapContextMenuObject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports